import { render } from "./Foot.vue?vue&type=template&id=6f73e6f4&scoped=true"
import script from "./Foot.vue?vue&type=script&lang=js"
export * from "./Foot.vue?vue&type=script&lang=js"

import "./Foot.vue?vue&type=style&index=0&id=6f73e6f4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f73e6f4"]])

export default __exports__